import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import styles from "@/index.css?inline";
import EkoElement from "@/utilities/element";
import style from "./progress-bar.css?inline";
import "@/components/visually-hidden";

@customElement("eko-progress-bar")
class ProgressBar extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(styles), unsafeCSS(style)];

  @property({ reflect: true })
  label?: string;

  @property({ reflect: true, type: Number })
  max?: number;

  @property({ reflect: true })
  theme?: string;

  @property({ reflect: true, type: Number })
  value?: number;

  render() {
    return html`
      <label part="root">
        <eko-visually-hidden>${this.label ? this.label : "Current progress"}</eko-visually-hidden>
        <progress
          part="progress"
          aria-valuenow=${ifDefined(this.value)}
          aria-valuemin="0"
          aria-valuemax=${this.max ? this.max : 100}
          value=${ifDefined(this.value)}
          max=${this.max ? this.max : 100}></progress>
      </label>
    `;
  }
}

export default ProgressBar;
